// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.enums.AnalyticsFilterSearchCategory

export enum AnalyticsFilterSearchCategory {
  ALL_USERS = 'ALL_USERS',
  AMENITY = 'AMENITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  DAYS_ON_ZILLOW = 'DAYS_ON_ZILLOW',
  HOME_TYPE = 'HOME_TYPE',
  KEYWORDS = 'KEYWORDS',
  LOT_SIZE = 'LOT_SIZE',
  MOVE_IN_DATE = 'MOVE_IN_DATE',
  PETS = 'PETS',
  PRICE = 'PRICE',
  SCHOOLS = 'SCHOOLS',
  SQUARE_FEET = 'SQUARE_FEET',
  TOURS = 'TOURS',
  VIEW = 'VIEW',
  YEAR_BUILT = 'YEAR_BUILT',
}

export const AnalyticsFilterSearchCategory_values = [
  AnalyticsFilterSearchCategory.ALL_USERS,
  AnalyticsFilterSearchCategory.AMENITY,
  AnalyticsFilterSearchCategory.BATHROOM,
  AnalyticsFilterSearchCategory.BEDROOM,
  AnalyticsFilterSearchCategory.DAYS_ON_ZILLOW,
  AnalyticsFilterSearchCategory.HOME_TYPE,
  AnalyticsFilterSearchCategory.KEYWORDS,
  AnalyticsFilterSearchCategory.LOT_SIZE,
  AnalyticsFilterSearchCategory.MOVE_IN_DATE,
  AnalyticsFilterSearchCategory.PETS,
  AnalyticsFilterSearchCategory.PRICE,
  AnalyticsFilterSearchCategory.SCHOOLS,
  AnalyticsFilterSearchCategory.SQUARE_FEET,
  AnalyticsFilterSearchCategory.TOURS,
  AnalyticsFilterSearchCategory.VIEW,
  AnalyticsFilterSearchCategory.YEAR_BUILT,
] as const;
